import { z } from 'zod';

export const AuthAppKeySchema = z.object({
  id: z.number(),
  name: z.string(),
  createdBy: z.object({
    id: z.number(),
    name: z.string(),
  }),
  accessorApplication: z.object({
    id: z.number(),
    name: z.string(),
  }),
  createdOn: z.coerce.date(),
  keyPrefix: z.string()
});
export type AuthAppKey = z.infer<typeof AuthAppKeySchema>;